import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import resources from './localization/resources'
import { readLanguage } from './localization/preferences'
import enLegacy from './lang/en/translation.json'
import ruLegacy from './lang/ru/translation.json'
import kyLegacy from './lang/kg/translation.json'

export const LANGUAGES = [
  { code: 'ky', label: 'Кыргызча', locale: 'ky-KG' },
  { code: 'ru', label: 'Русский', locale: 'ru-RU' },
  { code: 'en', label: 'English', locale: 'en-GB' },
]
const sourceNamespaces = new Map()
Object.entries(resources.ru).forEach(([namespace, entries]) => Object.keys(entries).forEach(source => sourceNamespaces.set(source, namespace)))
const reverse = new Map()
const templates = []
const escapePattern = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
LANGUAGES.forEach(({ code }) => Object.values(resources[code]).forEach(entries => Object.entries(entries).forEach(([source, target]) => {
  if (!reverse.has(target)) reverse.set(target, source)
  for (const text of new Set([source, target])) {
  if (text.includes('{{') && !text.includes('<') && text.replace(/\{\{[^}]+\}\}/g, '').trim().length > 3) {
    const names = []
    const parts = text.split(/(\{\{[^}]+\}\})/g).map(part => {
      if (!part.startsWith('{{')) return escapePattern(part)
      names.push(part.slice(2, -2).trim())
      return '(.+?)'
    })
    templates.push({ source, names, pattern: new RegExp('^' + parts.join('') + '$') })
  }
  }
})))
resources.ru.translation = ruLegacy
resources.ky.translation = kyLegacy
resources.en.translation = enLegacy
i18n.use(initReactI18next).init({
  resources, lng: readLanguage(), fallbackLng: 'ky', supportedLngs: ['ky', 'ru', 'en'],
  defaultNS: 'translation', ns: Object.keys(resources.ru),
  keySeparator: false, nsSeparator: false,
  interpolation: { escapeValue: false }, react: { useSuspense: false },
  returnNull: false, initImmediate: false,
})

export function tr(source, values) {
  if (typeof source !== 'string') return source
  const original = sourceNamespaces.has(source) ? source : reverse.get(source) || source
  const ns = sourceNamespaces.get(original)
  if (!ns && !values && source.length > 5) {
    for (const template of templates) {
      const match = template.pattern.exec(source)
      if (match) return i18n.t(template.source, { ns: sourceNamespaces.get(template.source), ...Object.fromEntries(template.names.map((name, index) => [name, tr(match[index + 1])])) })
    }
  }
  const localizedValues = values && Object.fromEntries(Object.entries(values).map(([key, value]) => [key, typeof value === 'string' ? tr(value) : value]))
  return i18n.t(original, { ns: ns || 'translation', defaultValue: original, ...localizedValues })
}
export function getLocale() { return LANGUAGES.find(item => item.code === i18n.language)?.locale || 'ky-KG' }
export function getCountryName(code, fallback) {
  try { return new Intl.DisplayNames([getLocale()], { type: 'region' }).of(code) || fallback }
  catch { return fallback }
}
function updateDocument() {
  document.documentElement.lang = i18n.language
  document.documentElement.dir = 'ltr'
  document.title = tr('Центр управления и контроля логистики ОАО «Кыргызкомур»')
}
i18n.on('languageChanged', updateDocument)
updateDocument()
export default i18n
